export default __webpack_public_path__ + "assets/mp3/745d6165c96f1a0f9fb172abc12839ad.mp3";